import { request } from '../lib/http'

export function fetchSyncServices (params) {
  return request({
    url: 'sync/service',
    method: 'get',
    params
  })
}
